import React, {useState, useEffect} from 'react'
import { isEmpty } from 'lodash';
import {
    Box,
    ThemeProvider,
  } from "@mui/material";

import useCompany from "../../hooks/use-company";

import theme from "../../theme";
import CustomToolBar from "../../components/custom-toolbar";
import CustomFooter from "../../components/custom-footer";

export default function NoData() {
  const { companyInfo } = useCompany();
  const [message, setMessage] = useState({title: "錯誤", message: "查無資料"});

  useEffect(() => {
    if(isEmpty(companyInfo)) setMessage({title: "查無公司資料", message: "請確認是否建立公司資訊"});
  }, [companyInfo]);

  return (
    <ThemeProvider theme={theme}>
      <CustomToolBar title={"錯誤"} />
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={1} minHeight="82.4dvh">
          <h1>{message.title}</h1>
          <h3>{message.message}</h3>
        </Box>
      <CustomFooter />
    </ThemeProvider>
  )
}
